/**
 * Defines shared pagination choices and the default page size.
 * Assumptions: Consumers opt into pagination and treat this shared configuration as read-only.
 */
const dataGridConstants = {
    defaults: {
        pageSizeOptions: [5, 10, 20, 50, 100],
        pageSize: 20
    }
};

export default dataGridConstants;
